__webpack_require__.p = "/position-observer/referrals-hub/";